import { useHistory, useParams } from "react-router-dom";
export const withAuth = (Component) => {
    const AuthRoute = () => {
        let { isbn } = useParams();
        let history = useHistory();
        const userVO = JSON.parse(localStorage.getItem('userVO'));
        if (userVO === null || userVO === undefined) {
            window.location.replace(window.location.origin + "/login");
        } else {
            return <Component />;
        }
    };
    return AuthRoute;
};
export const handleResponse = (response) => {
    if (!response.ok && response.status === 401) {
        // auto logout if 401 Unauthorized response returned from api
        localStorage.clear();
        window.location.replace(window.location.origin + "/login");
    }
    return response;
}
export const handleJwtTokenForKeppMeLoggedIn = (data) => {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    if (data.RefreshToken) {
        userVO.apJwtAuthenticationToken = data.RefreshToken;
        localStorage.setItem("userVO", JSON.stringify(userVO));
        localStorage.setItem("apJwtAuthenticationToken", data.RefreshToken);
    }
    return data;
}